define('view/controller/booking/datetime/classes/TimeClassesView',['require','view/controller/booking/datetime/TimeDefaultView','view/controller/booking/datetime/classes/TimeClassesProviderColumnView','Config','lib/Utils'],function (require) {

    var TimeDefaultView = require('view/controller/booking/datetime/TimeDefaultView');
    var TimeClassesProviderColumnView = require('view/controller/booking/datetime/classes/TimeClassesProviderColumnView');
    var Config = require('Config');
    var Utils = require('lib/Utils');

    /**
     * Flexible timeline view (container)
     *
     * @class TimeClassesView
     */
    return TimeDefaultView.extend({

        template: '#time_classes_view',
        childView: TimeClassesProviderColumnView,
        childViewContainer: '#sb_time_classes_container',
        childViewOptions: function (model) {
            return {
                'collection': model.get('collection'),
                'providerModel': this._providerCollection.getDataCollection().get(model.get('provider_id')),
                'slotsCount': this._totalSlots,
                'timeFrom': this._timeFrom,
                'timeTo': this._timeTo,
                'timeFrame': this._timeFrame
            };
        },

        _timeFrom: new Time(),
        _timeTo: new Time(),
        _totalSlots: 0,
        _timeFrame: 5,
        _timeCollection: null,
        _classesCollection: null,
        _providerCollection: null,
        _serviceCollection: null,
        _clientTimezone: null,
        _bookingModel: null,

        initialize: function () {
            this._classesCollection = this.getOption('classesCollection');
            this._providerCollection = this.getOption('providerCollection');
            this._serviceCollection = this.getOption('serviceCollection');
            this._clientTimezone = this.getOption('clientTimeZone');
            this._bookingModel = this.getOption('bookingModel');

            this.listenTo(this._classesCollection, 'sync', this.updateTimeLine);
            this.listenTo(this._providerCollection, 'sync', this.updateTimeLine);
            this.listenTo(this._serviceCollection, 'sync', this.updateTimeLine);
            this.listenTo(this._clientTimezone, 'sync', this.updateTimeLine);

            TimeDefaultView.prototype.initialize.apply(this);

            if (this._classesCollection.length) {
                this.updateTimeLine();
            }
        },

        updateTimeLine: function () {
            this._providerCollection.performFilters();

            this.collection = this._classesCollection.getProviderCollection(
                this._providerCollection.pluck('id')
            );
            if (!this._clientTimezone.isReady()) {
                return;
            }

            this._timeCollection = this._classesCollection.getTimeCollection();

            var from = this._timeCollection.first();
            var to = this._timeCollection.last();

            if (from && to) {
                this._timeFrom = new Time(from.get('time'));
                this._timeTo = new Time(to.get('time'));

                this._timeFrame = Config.getInstance().getTimeFrame();
            }

            this._totalSlots = this._timeCollection.length;
            this.render();
        },

        getTimeCollection: function () {
            return this._classesCollection;
        },

        serializeData: function () {
            var result = TimeDefaultView.prototype.serializeData.apply(this);
            if (this._timeCollection) {
                var clientTimeZone = this.getOption('clientTimeZone');
                // hour labels use the per-date offset of their row (DST), "now" difference only as fallback
                result.available_time = _.map(this._timeCollection.toJSON(), function (item) {
                    item.time_diff = Utils.timeDiff(item, clientTimeZone);
                    return item;
                });
            }

            result.services = this._serviceCollection.toJSON();
            return result;
        }

    });

});
